import { useCapability } from 'navigation-components/platform/hooks';
import { capabilities } from 'navigation-components/capabilities';
import { useCallback, useEffect } from 'react';
import { loadCSATSurvey } from '../../utils/loadCSATSurvey';
export const useSubscribeToCsatSurveys = () => {
  const {
    subscribe: subscribeToSurveyUpdates
  } = useCapability(capabilities.TOGGLE_CSAT_SURVEY_CAP.getName());
  const handleSurveyChange = useCallback(({
    surveyId
  }) => {
    loadCSATSurvey(surveyId);
  }, []);
  useEffect(() => {
    return subscribeToSurveyUpdates(handleSurveyChange);
  }, [handleSurveyChange, subscribeToSurveyUpdates]);
};